import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';


export default class ContractProgramsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args
        var contract = {value: 0, name: ""}
        var program = {name: ""}
        var caption = "Программы"
        
        if (props.args.contract) {
            contract = props.args.contract
        } 

        if (props.args.program) {
            program = props.args.program
        }

        if (props.args.caption) {
            caption = props.args.caption    
        }

    
        this.state = {
              args: args, 
              programs: [],
              contract: contract, 
              program: program,
              caption: caption
        }

    }  
    
    async componentDidMount() {
        BaseApi.get('/contract/programs', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {contractid: this.props.args.contractid, programid: this.props.args.programid}, withCredentials: true})
        .then(res => {
            this.setState({programs: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openContractProgram(id) {
        this.props.navigate("contract-program", 
            {caller: "contract-programs", 
             callargs: this.state.args, 
             id: id, 
             contract: this.state.contract.name,
             program: this.state.program.name,
             contractid: this.state.args.contractid,
             programid: this.state.args.programid    
            }
        )
    }

    renderProgram(program) {
        return (
            <div class="row" style={{"height" : "50px"}}>
                    {(this.props.args.programid === undefined || this.props.args.programid === null) &&
                    <div class="col-4 text-left border border-white"
                         style={{"background-color" : "#eee"}}>{program.program}</div>
                    }     

                    {(this.props.args.contractid === undefined || this.props.args.contractid === null) &&
                    <div class="col-4 text-left border border-white"
                         style={{"background-color" : "#eee"}}>{program.contract}</div>
                    }     
                    <div class="col-2 text-left border border-white"
                         style={{"background-color" : "#eee"}}>{program.value}</div>            
                    <div class="col-1 border border-white"
                         style={{"background-color" : "#eee"}} onClick={()=>this.openContractProgram(program.id)}><img src={details} height="16" width="16"/></div>
            </div>
        )      
    }

    render() {
        return (
            <div class="container">
            <ScreenCaption goback={this.props.goback} args={this.state.args} caption={this.state.caption}/>
            <div class="row mt-5" style={{"height" : "50px"}}>
                    
                    {(this.props.args.programid === undefined || this.props.args.programid === null) &&
                    <div class="col-4 text-left border border-white"
                         style={{"background-color" : "#0ee"}}>Программа</div>
                    }     

                    {(this.props.args.contractid === undefined || this.props.args.contractid === null) &&     
                    <div class="col-4 text-left border border-white"
                         style={{"background-color" : "#0ee"}}>Контракт</div>
                    }     
                    <div class="col-2 text-left border border-white"
                         style={{"background-color" : "#0ee"}}>Сумма</div>  
                    <div class="col-1 border border-white"
                         style={{"background-color" : "#0ee"}}
                         onClick={()=>{this.openContractProgram("")}}><img src={add} height="16" width="16"/>
                    </div>     
                </div>    
           
            {this.state.programs.map((value, index) => this.renderProgram(value))}
        </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/contract-programms.js